export const Menue = {
  Header: {
    AppName: 'ヘルスケアアプリ',
    Search: '検索',
  },
  UserInfo: {
    CustomerNumber: 'お客様番号：{0}',
    Show: 'QRコードを表示',
    Hide: 'QRコードを非表示',
    UserName: '患者さまのお名前',
    Identification: {
      Approved: '承認済',
      Unapproved: '未承認',
      Checking: '承認確認中',
    },
  },
  Bottom: {
    Home: 'ホーム',
    MmedicineBook: 'お薬手帳',
    MedicationRecord: '服薬記録',
    BodyRecord: '健康データ',
    MyPage: 'マイページ',
    Message: 'メッセージ',
    Shopping: 'お買い物',
    AlarmSetting: 'アラーム設定',
  },
  LeadToLogin: {
    Login: 'ログイン',
    Ok: 'OK',
    Cancel: 'キャンセル',
    Message:
      'この機能をご利用いただくにはタヨリスアカウントでのログインが必要です。',
  },
  DayOfWeek: {
    Sun: '日',
    Mon: '月',
    Tue: '火',
    Wed: '水',
    Th: '木',
    Fri: '金',
    Sat: '土',
    Sunday: '日曜日',
    Monday: '月曜日',
    Tuesday: '火曜日',
    Wednesday: '水曜日',
    Thursday: '木曜日',
    Friday: '金曜日',
    Saturday: '土曜日',
  },
  Address: {
    PostalPrefix: '〒',
  },
  Select: {
    UnSelect: '未選択',
  },
};

//DialogのButtonは消してButtonの方にしたい
export const Dialog = {
  Button: {
    Ok: 'OK',
    Cancel: 'キャンセル',
    Yes: 'はい',
    No: 'いいえ',
    Delete: '削除',
  },
  Text: {
    DeleteConfirm: '本当に削除しますか',
  },
};

export const Button = {
  Button: {
    Ok: 'OK',
    Cancel: 'キャンセル',
    Yes: 'はい',
    No: 'いいえ',
    Close: '閉じる',
    Delete: '削除する',
    Update: '更新する',
  },
};

export const StringMark = {
  Required: '※必須',
  Edit: '編集',
  Delete: '削除',
  Hidden: '非表示',
  Redisplay: '再表示',
};
export const UserInfo = {
  Form: {
    Name: 'お名前（漢字）',
    ForeignNameAttention: '※外国籍の方は、ローマ字で入力して下さい。',
    NameKana: 'お名前（カタカナ）',
    Gender: '性別',
    Birthday: '生年月日',
    Weight: '体重',
  },
  NotLoggedInText: 'ログインしていません',
  Dialog: {
    NotLoggedInWaringMessage: 'このアプリはログインしなくても利用できますが、その場合、機種変更やアプリを入れ直すと、データは引き継げず消えてしまいます。\nログインしないで利用した場合のデータは、アカウントを登録しても引き継ぐことができませんのでご注意ください。',
  }
};

export const FormParts = {
  Update: '更新',
  Updated: '更新しました。',
  Validation: {
    invalidInput: '無効な入力値です。',
    invalidNameKana: '全角カタカナのみで入力してください。',
  },
};

export const SpecialString = {
  FullWidthTilde: '～',
  FullWidthDoubleColon: '：',
};

export const ApiErrorMessage = {
  generalError: 'エラーが発生しました。しばらく時間をおいてお試しください。',
  s3UploadError:
    '画像のアップロードに失敗しました。\nネットワーク環境をご確認の上、再度お試しください。',
};

export const InputErrorMessage = {
  Required: 'この項目は必須です。',
  NotSelected: '少なくとも1つ以上を選択してください。',
  IntegerOnly: '整数で入力してください。',
  ExceedStringLengthLimit: '{0}文字以内で入力してください。',
  ExceedStringLengthWithin: '{0}文字から{1}文字で入力してください。',
  ExceedStringLengthJust: '{0}文字で入力してください。',
  ExceedNumberLengthLimit: '{0}桁以内で入力してください。',
  ExceedNumberLengthWithin: '{0}桁から{1}桁で入力してください。',
  ExceedNumberLengthJust: '{0}桁で入力してください。',
  ExceedNumberOfDecimalPlacesWithin: '小数点以下{0}桁以内で入力してください。',
  NotNumeric: '半角数字で入力してください。',
  BothNotEnteredPhoneNumber:
    '電話番号、または携帯番号のいずれかを入力してください。',
  NotFullSizeKatakana: '全角カタカナで入力してください。',
  NotNumericOrHyphen: '半角数字またはハイフンを入力してください。',
  ExceedNumberValueWithin: '{0}~{1}の数字で入力してください。',
  FutureDate: '現在以降のデータは登録できません。',
  MistakeInput: '入力内容に誤りがあります。',
  OverdueDateTime: '予約可能日時を過ぎています。日時を変更してください。',
};
